/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgItalicS = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m1557 201-38 195q-34-23-76-41t-89-31-92-20-87-7q-59 0-117 15t-105 48-74 81-29 117q0 63 23 113t62 92 87 80 100 76 101 79 87 90 61 110 24 136q0 50-9 98t-30 94q-34 77-87 128t-121 81-142 44-154 13q-51 0-107-6t-111-20-108-32-98-44l33-195q43 29 92 52t100 40 105 25 106 9q64 0 123-13t106-45 73-81 28-124q0-58-23-104t-62-87-88-76-101-75-101-80-88-93-62-116-24-145q0-76 22-141t62-118 98-94 126-65q56-20 116-28t119-8q91 0 188 19t181 54z"
    }));
export default SvgItalicS;
